import { ImageSd } from './image.sd';

export class PublisherSd {
  '@type' = 'Organization';
  '@id': string;
  name = 'Boxdelivery';
  url: string;
  sameAs = ['https://www.facebook.com/boxdelivery.be', 'https://www.instagram.com/boxdelivery.be/'];
  logo: ImageSd;

  constructor(baseUrl: string, logoUrl: string) {
    this.url = baseUrl;
    this['@id'] = baseUrl + '/#Organization';
    this.logo = new ImageSd(logoUrl);
  }
}
